<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('CHECKMANAGEMENT_EDIT')"
                  type="text"
                  @click="editUser"
                  :disabled="this.selected.length != 1"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('CHECKMANAGEMENT_DELETE')"
                  type="text"
                  @click="deleteUser"
                  :disabled="this.selected.length != 1"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('CHECKMANAGEMENT_ADD')"
                  type="text"
                  @click="addUser"
                  >{{ $t("common.btn.add") }}</el-button
                >
              </div>
              <div class="table">
                <el-table
                  class="t1"
                  row-key="id"
                  ref="carTable"
                  :data="list"
                  border
                  stripe
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" width="40">
                  </el-table-column>
                  <el-table-column
                    :label="$t('common.id')"
                    prop="checkIndex"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :label="$t('PlatformSettings.checkName')"
                    prop="checkName"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    :label="$t('PlatformSettings.benchmark')"
                    prop="checkReference"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="id"
                    type="index"
                    :label="$t('PlatformSettings.operate')"
                    align="center"
                    class-name="handle"
                    width="100px"
                  >
                    <i class="el-icon-rank" style="font-size: 14px" />
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="checkName"
            :label="$t('PlatformSettings.checkName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.checkName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="checkReference"
            :label="$t('PlatformSettings.benchmark') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.checkReference"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import checkManagement from "./checkManagement";
export default checkManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
.table {
  /deep/.el-table {
    background-color: transparent;
    th {
      font-size: 14px;
      color: #fff;
      background-color: #2a548e;
      padding: 0;
      height: 40px;
    }
    tr {
      background-color: #081831;
    }
    tr:hover > td {
      background-color: #081831;
    }
    td {
      font-size: 13px;
      color: #fff;
      height: 35px;
      padding: 0;
      .el-tag {
        background-color: transparent;
        font-size: 13px;
        height: 24px;
        line-height: 24px;
        border: none !important;
      }
    }
    .el-button {
      background-color: transparent;
      border: none;
      border-radius: 0;
      color: #409eff;
      padding: 0;
    }
    .el-button.is-disabled,
    .el-button.is-disabled:focus,
    .el-button.is-disabled:hover {
      color: #c0c4cc;
    }
    .el-checkbox__inner {
      border-color: #697c97;
      background-color: transparent;
      border-radius: 0;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #409eff;
      border-color: #409eff;
    }
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #409eff;
    }
    .el-table__body tr.hover-row > td {
      background-color: transparent !important;
    }
  }
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #1b2943 !important;
  }
  /deep/.el-table__fixed-body-wrapper {
    top: 40px !important;
  }
  .el-table::before {
    height: 0;
  }
  .el-table--border::after {
    background-color: rgba(180, 185, 209, 0.15);
  }
  /deep/.el-table__fixed-right::before {
    background-color: transparent;
  }
  /deep/.el-table--border {
    border-color: rgba(180, 185, 209, 0.15);
    th,
    td {
      border-bottom-color: rgba(180, 185, 209, 0.15);
      border-right-color: rgba(180, 185, 209, 0.15);
    }
  }
  /deep/.iconicon-chakanxq:before {
    color: #409eff;
  }
  /deep/.el-table td.el-table__cell {
    border-color: rgba(180, 185, 209, 0.15);
  }
  /deep/.handle {
    background-color: transparent;
  }
  /deep/.el-table th.el-table__cell.is-leaf {
    border-color: rgba(180, 185, 209, 0.15);
  }
}
</style>
